import React from "react";
import { Pencil, Users } from "lucide-react";

export default function OwnersHeader({ setIsModalOpen }) {

  const handleEditClick = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-theme-50">
          <Users className="h-5 w-5 text-theme-600" aria-hidden="true" />
        </div>
        <div>
          <h2 className="font-semibold text-slate-900">
            Lead Owners
          </h2>
          <p className="mt-0.5 text-sm text-slate-500">People responsible for this lead.</p>
        </div>
      </div>

      <button
        type="button"
        onClick={handleEditClick}
        aria-label="Edit lead owners"
        className="flex flex-shrink-0 items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-600 transition-colors hover:border-theme-200 hover:bg-theme-50 hover:text-theme-700"
      >
        <Pencil className="h-4 w-4" aria-hidden="true" />
        Edit
      </button>
    </div>
  );
}
